import { cx } from 'class-variance-authority';
import { useState } from 'react';
import type { ResponsiveType } from 'react-multi-carousel';

import Image from '@/app/components/Image';
import MultiCarousel from '@/app/components/MultiCarousel';
import { RESPONSIVE_DATA } from '@/app/components/MultiCarousel/constants';

import FsaSlideshowNavigation from './FsaSlideshowNavigation';
import type { ProductImage } from './types';

const SLIDESHOW_IMAGES: ProductImage[] = [
  {
    src: 'product/simple/pdp-img-carousel-silver-01-heritage@2x.png',
    alt: 'heritage_ring_slide_1_alt',
  },
  {
    src: 'fsa-hsa-info/horizon-rings.png',
    alt: 'horizon_rings_slide_2_alt',
  },
  {
    src: 'fsa-hsa-info/heritage-rings.png',
    alt: 'heritage_rings_slide_3_alt',
  },
  {
    src: 'fsa-hsa-info/app_heartrate_975.png',
    alt: 'heart_rate_slide_4_alt',
  },
  {
    src: 'fsa-hsa-info/app_spo2_975.png',
    alt: 'spo2_slide_5_alt',
  },
];

const RESPONSIVE = {
  desktop: { ...RESPONSIVE_DATA['desktop'], items: 1 },
  tablet: { ...RESPONSIVE_DATA['tablet'], items: 1 },
  mobile: { ...RESPONSIVE_DATA['mobile'], items: 1 },
} as ResponsiveType;

const FsaProductSlideshow = (): JSX.Element => {
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const handleChange = (nextSlide: number) => {
    setActiveSlide(nextSlide);
  };

  return (
    <section>
      <MultiCarousel
        arrows={false}
        shouldResetAutoplay={false}
        autoPlay={false}
        showDots={false}
        renderButtonGroupOutside={true}
        responsive={RESPONSIVE}
        beforeChange={(nextIndex) => setActiveSlide(nextIndex)}
        customButtonGroup={
          <FsaSlideshowNavigation
            images={SLIDESHOW_IMAGES}
            onChange={handleChange}
          />
        }
      >
        {SLIDESHOW_IMAGES.map(({ alt, src }, idx) => (
          <div
            key={src}
            className={cx('pointer-events-none select-none', {
              'opacity-1 transition-opacity-750 transition-visibility-750 visible':
                activeSlide === idx,
              'transition-opacity-100 transition-visibility-100 hidden opacity-0':
                activeSlide !== idx,
            })}
          >
            <Image
              localizedAlt={alt}
              priority={idx === 0}
              src={src}
              draggable="false"
              width={975}
              height={900}
              className="aspect-4/3 w-full"
            />
          </div>
        ))}
      </MultiCarousel>
    </section>
  );
};

export default FsaProductSlideshow;
